import AppTour from '@components/tour/AppTour';
import { TOUR_ID } from '@components/tour/tours';

/**
 * `AppTour` as the finished video results see it.
 *
 * Mount it only once the results view has rendered: the engine checks once, on mount, whether any step has
 * something to point at, and the loader shown before has nothing. It needs no stages — every step points at
 * something already on the page, and the steps a project lacks (no flight data, one version) are dropped.
 *
 * `suppressed` while correcting: the toolbar is an edit mode, and a mask over it would trap a half-made fix.
 * `onOpenChange` lets the page hold its shortcuts (Ctrl+Z undoes a fix) while the tour is open.
 */
const ResultsTour = ({ suppressed = false, onOpenChange }) => (
	<AppTour tourId={TOUR_ID.VIDEO_RESULTS} suppressed={suppressed} onOpenChange={onOpenChange} />
);

export default ResultsTour;
